import React from "react";
import { Link } from "react-router-dom";
import HeroSection from "./Sections/HeroSection";
import FeaturesSection from "./Sections/FeaturesSection";
import CTASection from "./Sections/CTASection";
import PartnersSection from "./Sections/PartnersSection";
import TestimonialsSections from "./Sections/TestimonialsSections";
import FAQSection from "./Sections/FAQSection";
import FooterSection from "./Sections/FooterSection";
import BenifitsSection from "./Sections/BenefitsSection";

export default function LandingPageContent({ site, pageContent, handleOpen = () => {} }) {
  const siteLogo = site?.image_logo || site?.square_logo || site?.image_favicon;
  const heroData = pageContent?.hero;
  const partnersData = pageContent?.partners;
  const featuresData = pageContent?.features;
  const testimonialsData = pageContent?.testimonials;
  const newsletterData = pageContent?.newsletter;
  const faqData = pageContent?.faqs;
  const footerData = pageContent?.footer;
  const benefitsData = pageContent?.benefits;
  const calltoActionData = pageContent?.call_to_action;

  return (
    <div className="relative h-full w-full bg-white">
      <header className="relative z-50">
        <nav
          aria-label="Global"
          className="flex items-center justify-between px-12 py-8">
          {siteLogo && (
            <div className="flex">
              <div className="-m-1.5 p-1.5">
                <span className="sr-only">Your Company</span>
                <img
                  alt=""
                  src={siteLogo}
                  className="h-12 w-auto"
                />
              </div>
            </div>
          )}
          <div className="flex justify-end">
            <Link
              to="/login"
              className="rounded-md border border-indigo-600 p-2 px-6 font-semibold text-indigo-600 transition-colors duration-300 hover:bg-indigo-400 hover:text-white">
              Log in <span aria-hidden="true">→</span>
            </Link>
          </div>
        </nav>
      </header>

      <main className="isolate">
        <HeroSection
          data={heroData}
          handleOpen={handleOpen}
        />

        <PartnersSection
          data={partnersData}
          handleOpen={handleOpen}
        />

        <FeaturesSection
          data={featuresData}
          handleOpen={handleOpen}
        />

        <BenifitsSection
          data={benefitsData}
          handleOpen={handleOpen}
        />

        <TestimonialsSections
          data={testimonialsData}
          handleOpen={handleOpen}
        />

        <CTASection
          data={calltoActionData}
          handleOpen={handleOpen}
        />

        <FAQSection
          data={faqData}
          handleOpen={handleOpen}
        />

        <FooterSection
          data={footerData}
          newsletterData={newsletterData}
          handleOpen={handleOpen}
        />
      </main>
    </div>
  );
}
